import { buildUrl } from "./auth";

const buildQuery = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  return parts.length ? `?${parts.join("&")}` : "";
};

const parseFileName = (response) => {
  const disposition = response.headers.get("content-disposition") || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return match?.[1] || null;
};

const fetchExport = async (path) => {
  const response = await fetch(buildUrl(path), { credentials: "include" });
  if (!response.ok) {
    const message = await response.text().catch(() => "");
    throw new Error(message || "Export failed.");
  }
  const blob = await response.blob();
  return { blob, fileName: parseFileName(response) };
};

export const exportAdminRevenue = (params) =>
  fetchExport(`/api/admin/exports/revenue${buildQuery(params)}`);

export const exportAdminVat = (params) =>
  fetchExport(`/api/admin/exports/vat${buildQuery(params)}`);

export const exportAdminAccountant = (params) =>
  fetchExport(`/api/admin/exports/accountant${buildQuery(params)}`);

export const exportAdminBookings = () => fetchExport("/api/admin/exports/bookings");

export const exportAdminPayments = () => fetchExport("/api/admin/exports/payments");

export const exportAdminPartners = () => fetchExport("/api/admin/exports/partners");

const adminExportsApi = {
  exportAdminRevenue,
  exportAdminVat,
  exportAdminAccountant,
  exportAdminBookings,
  exportAdminPayments,
  exportAdminPartners,
};

export default adminExportsApi;
